import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const useDeliverableInsightsMessages = (isLoading, interval = 3000) => {
  const { t } = useTranslation();
  const [currentMessageIndex, setCurrentMessageIndex] = useState(0);

  const messages = [
    t("deliverable_insights.loading_messages.message1"),
    t("deliverable_insights.loading_messages.message2"),
    t("deliverable_insights.loading_messages.message3"),
    t("deliverable_insights.loading_messages.message4"),
    t("deliverable_insights.loading_messages.message5"),
    t("deliverable_insights.loading_messages.message6"),
  ];

  useEffect(() => {
    if (!isLoading) {
      setCurrentMessageIndex(0);
      return;
    }

    const messageInterval = setInterval(() => {
      setCurrentMessageIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, interval);

    return () => clearInterval(messageInterval);
  }, [isLoading, interval, messages.length]);

  return messages[currentMessageIndex] || "";
};

export default useDeliverableInsightsMessages;
